module.exports = __webpack_public_path__ + "static/media/ring.cff5aef5.mp3";